import { parsePhoneNumberWithError } from 'libphonenumber-js'
import * as Yup from 'yup'

export const PROPERTY_TYPE_OPTIONS = [
  { value: '', label: 'Select property type' },
  { value: 'House', label: 'House' },
  { value: 'Unit', label: 'Unit' },
  { value: 'Townhouse', label: 'Townhouse' },
  { value: 'Land', label: 'Land' },
  { value: 'Commercial', label: 'Commercial' },
  { value: 'Acreage', label: 'Acreage' },
  { value: 'Rural', label: 'Rural' },
  { value: 'Project/Development', label: 'Project/Development' },
  { value: 'Other', label: 'Other' },
]

export const APPRAISAL_TYPE_OPTIONS = [
  { label: 'Sale', value: 'Sale' },
  { label: 'Rental', value: 'Rentals' },
  { label: 'Both Sale and Rental', value: 'Both' },
]

export const INITIAL_VALUES = {
  appraisal_type: '',
  address_full_text: '',
  property_type: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  notes: '',
  address_postcode: '',
  address_suburb: '',
  agree_to_terms: false,
  credit_card: '',
  recaptcha: '',
}

export const STAGED_FEATURE_PILLS = ['60 SECONDS', 'NO OBLIGATION', 'PRIVATE']

export const TOTAL_STEPS = 3

// Which form the visitor sees. Assigned by the appraisal dispersal API and sent
// back on every submission so partial and completed requests can be reported on
// per variant. The API stores workflow_variant as free text, so the front end is
// what keeps these values honest - never forward an unrecognised one.
export const WORKFLOW_VARIANTS = {
  STANDARD: 'standard',
  WIZARD_A: 'wizard-a',
}

export const SUBMISSION_STATUS = {
  PARTIAL: 'partial',
  COMPLETE: 'complete',
}

// Fields sent to the appraisal request API for each step. Includes the address
// parts resolved by GooglePlacesToAppraisalAddress, which aren't validated
// fields so aren't covered by STEP_FIELDS below.
export const STEP_PAYLOAD_FIELDS = {
  1: [
    'property_type',
    'address_full_text',
    'address_unit_no',
    'address_sub_number',
    'address_street_no',
    'address_street_number',
    'address_street_name',
    'address_suburb',
    'address_state',
    'address_state_short',
    'address_postcode',
  ],
  2: ['first_name', 'last_name', 'email', 'phone'],
  3: ['appraisal_type', 'notes'],
}

const REQUIRED_ERROR = 'THIS FIELD IS REQUIRED'

const phoneValidation = Yup.string()
  .required(REQUIRED_ERROR)
  .test('is-valid', 'Please enter a valid phone number', function (value) {
    if (!value) return this.createError({ message: REQUIRED_ERROR })
    let phoneValue = value
    if (phoneValue.indexOf('+61') > -1) {
      phoneValue = phoneValue.replace(/ /g, '').replace('+61', '')
    }
    const phoneNumber = parsePhoneNumberWithError(phoneValue, 'AU')
    if (phoneNumber) {
      if (phoneNumber.isValid()) {
        return true
      } else if (phoneNumber.isPossible()) {
        if (
          phoneNumber.nationalNumber.length == 8 &&
          phoneNumber.countryCallingCode == 61
        ) {
          return true
        }
        return false
      }
    }
    return false
  })

const addressValidation = {
  address_full_text: Yup.string().required(REQUIRED_ERROR),
  address_postcode: Yup.string().required(REQUIRED_ERROR),
  address_suburb: Yup.string().required(REQUIRED_ERROR),
}

const step1Schema = Yup.object().shape({
  property_type: Yup.string().required(REQUIRED_ERROR),
  ...addressValidation,
})

const step2Schema = Yup.object().shape({
  first_name: Yup.string().required(REQUIRED_ERROR),
  last_name: Yup.string().required(REQUIRED_ERROR),
  email: Yup.string()
    .email('Please enter a valid email')
    .required(REQUIRED_ERROR),
  phone: phoneValidation,
})

const step3Schema = Yup.object().shape({
  appraisal_type: Yup.string().required(REQUIRED_ERROR),
  agree_to_terms: Yup.boolean().oneOf([true], REQUIRED_ERROR),
})

export const fullValidationSchema = step1Schema
  .concat(step2Schema)
  .concat(step3Schema)

export const STEP_FIELDS = {
  1: [
    'property_type',
    'address_full_text',
    'address_postcode',
    'address_suburb',
  ],
  2: ['first_name', 'last_name', 'email', 'phone'],
  3: ['appraisal_type', 'agree_to_terms'],
}

export const STEP_SCHEMAS = {
  1: step1Schema,
  2: step2Schema,
  3: step3Schema,
}
